// composables/useToast.ts
import { ref } from 'vue';

type ToastKind = 'success' | 'error' | 'info';
type Toast = { id: number; kind: ToastKind; text: string; timeout?: number };

const toasts = ref<Toast[]>([]);
let id = 1;

export function useToast() {
  function push(text: string, kind: ToastKind = 'info', timeout = 3000) {
    const t: Toast = { id: id++, kind, text, timeout };
    toasts.value.push(t);
    if (timeout > 0) {
      setTimeout(() => dismiss(t.id), timeout);
    }
  }
  function success(text: string, timeout = 10000) {
    push(text, 'success', timeout);
  }
  function error(text: string, timeout = 10000) {
    push(text, 'error', timeout);
  }
  function info(text: string, timeout = 10000) {
    push(text, 'info', timeout);
  }
  function dismiss(id: number) {
    const i = toasts.value.findIndex((t) => t.id === id);
    if (i >= 0) toasts.value.splice(i, 1);
  }
  return { toasts, push, success, error, info, dismiss };
}
